import {SxStyles} from "../../../../../../types";
import theme from "../../../../../../theme";
import {getResponsiveSize} from "../../../../../../utils";

export const ImageContentPanelStyle: SxStyles = {
    imageTabContainer: {
        display: "flex",
        justifyContent: "center",
        flexDirection: 'column',
        flexWrap: 'nowrap',
        alignItems: "center",

        '& .image-container': {
            pt: `calc(${theme.palette.propVars?.index} *  0.555)`,
            width: getResponsiveSize(468),
            height: getResponsiveSize(258),
            '& img' : {
                height: '100%',
                borderRadius: theme.palette.propVars?.borderRadius,
                margin: "auto",
            },
            '& .image-default': {
                height: `100%`,
                '& img': {
                    height: getResponsiveSize(152),
                    width: getResponsiveSize(152),
                }
            },

        },

    },

}